import { Text } from '@/shared/ui/Text';
import styles from './PetsPage.module.scss';

export const PetsPage = () => {
    return (
        <main className={styles.main}>
            <Text size='l'>Страница в разработке...</Text>
        </main>
    );
};